import React, { createContext, useContext, useMemo } from "react";
import { useMatches, UIMatch } from "react-router-dom";
import { RouteHandle } from "@/routes";
import { AnalyticsEvent } from "@/hooks/useAnalytics";

interface FilterEnabledContextType {
  isEnabled: boolean;
  filterAnalyticsEvent?: AnalyticsEvent;
}

const FilterEnabledContext = createContext<FilterEnabledContextType | null>(
  null,
);

export function FilterEnabledProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const routeMatches = useMatches() as UIMatch<
    undefined,
    RouteHandle | undefined
  >[];

  const value = useMemo(() => {
    const currentMatch = routeMatches[routeMatches.length - 1];
    return {
      isEnabled: !!currentMatch?.handle?.allowFilters,
      filterAnalyticsEvent: currentMatch?.handle?.filterAnalyticsEvent,
    };
  }, [routeMatches]);

  return (
    <FilterEnabledContext.Provider value={value}>
      {children}
    </FilterEnabledContext.Provider>
  );
}

export function useFilterEnabled() {
  const context = useContext(FilterEnabledContext);
  if (!context) {
    return {
      isEnabled: false,
      filterAnalyticsEvent: undefined,
    };
  }
  return context;
}
